import { render, staticRenderFns } from "./OfflineClaim.vue?vue&type=template&id=4650c87c&"
import script from "./OfflineClaim.vue?vue&type=script&lang=js&"
export * from "./OfflineClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports